import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { useModelKey, useValue, WhenModelValue } from '@morningtrain/react-resources'
import EmploymentAction from 'widgets/employments/EmploymentAction'
import OnClickPipeline from 'support/pipelines/OnClickPipeline'
import * as UI from 'ui'
import PreviewContractModal from 'widgets/modals/PreviewContractModal'
import { SpawnComponentOnPipe } from '@morningtrain/react-spawner'
import { Can, CanUseModel } from '@morningtrain/react-auth'
import DeleteModelOnClick from '../../support/actions/generic/DeleteModelOnClick'
import DeleteButton from '../../ui/buttons/DeleteButton'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import Permissions from 'services/Permissions'
import EditEmploymentSmartview from 'pages/app/hr/employments/smartviews/EditEmploymentSmartview'
import WhenEmploymentIsDraft from 'pages/app/hr/employments/partials/WhenEmploymentIsDraft'
import { Link } from '@morningtrain/react-navigation'
import ReactivateEmploymentUserForm from 'pages/app/users/ReactivateEmploymentUserForm'

export default function EmploymentActions ({ isEdit = false }) {
  const contractId = useValue('contract_id')

  const modelKey = useModelKey()

  return (
          <>
            <DeleteModelOnClick>
              <DeleteButton big/>
            </DeleteModelOnClick>

            <WhenEmploymentIsDraft negate>
              {!isEdit && <Can permission={Permissions.EMPLOYMENTS_UPDATE_EMPLOYMENT}>
                <MountSmartviewOnClick smartview={<EditEmploymentSmartview id={modelKey}/>} replace={false}>
                  <UI.Button color="outlineLight">
                    <Translation name="actions.change_employment"/>
                  </UI.Button>
                </MountSmartviewOnClick>
              </Can>}
            </WhenEmploymentIsDraft>

            <WhenModelValue name="user.active" condition={false}>
              <ReactivateEmploymentUserForm/>
            </WhenModelValue>

            <WhenModelValue name="is_danish_citizen" condition={false}>
              <EmploymentAction title={<Translation name="actions.permit"/>}>
                {null}
              </EmploymentAction>
            </WhenModelValue>

            {!isEdit && <Can permission="app.contracts.file">
              <WhenModelValue name="contract_id" condition={v => !!v}>
                <WhenModelValue name="status" condition={s => s === 'draft' || s === 'approved' || s === 'employed'}>
                  <OnClickPipeline trigger={(
                          <UI.Button color="lightgray">
                            <Translation name="actions.preview"/>
                          </UI.Button>
                  )}
                  >
                    <SpawnComponentOnPipe component={<PreviewContractModal contractId={contractId} defaultOpen/>}/>
                  </OnClickPipeline>
                </WhenModelValue>
              </WhenModelValue>
            </Can>}

            {!isEdit && <CanUseModel permission="app.employments.file">
              <Link newTab route="app.employments.file" parameters={{ employment: 'model:id' }}>
                <UI.Button>
                  <UI.WithIcon icon={<UI.Icons.Download/>}>
                    <Translation name="hr.employments.actions.download"/>
                  </UI.WithIcon>
                </UI.Button>
              </Link>
            </CanUseModel>}

            {!isEdit && (
                    <>
                      <WhenModelValue name="detailed_status" condition={value => [
                        'approved_awaiting_contract_is_rejected',
                        'approved_awaiting_contract_is_rejected_by_employee',
                        'approved_awaiting_contract_is_rejected_by_employer'
                      ].includes(value)
                      }>
                        <EmploymentAction action="refresh"/>
                      </WhenModelValue>
                      <EmploymentAction action="activate"/>
                      <EmploymentAction action="approve"/>
                      <CanUseModel permission="app.employments.sign_contract">
                        <Link newTab route="app.employments.sign_contract" parameters={{ employment: modelKey }}>
                          <UI.Button>
                            <Translation name="tablet.signing.sign_contract"/>
                          </UI.Button>
                        </Link>
                      </CanUseModel>
                    </>
            )}
          </>
  )
}
